import styled from 'styled-components';
import { HEADER_HEIGHT } from '../../utils/consts';

export const WrapperS = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 20px;
  height: ${HEADER_HEIGHT};
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  position: relative;
`;

export const MenuBtnS = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    content: '';
    font-family: 'Ionicons';
    font-size: 26px;
    color: inherit;
    line-height: 0;
  }
`;

export const BannerS = styled.div`
  flex: 1;
  height: 100%;
  margin: 0 20px;
  background: rgba(0, 0, 0, 0.05);
`;

export const SelectId2WrapperS = styled.div`
  display: flex;
  align-items: center;
`;
